<template>
  <v-app>
    <v-main>
      <vue-progress-bar> </vue-progress-bar>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import globalStore from "@/store/index.js";

export default {
  name: "App",
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule("global", globalStore);
  }
};
</script>
<style lang="scss">
  @import '@/scss/variable.scss';
  @import '@/scss/app.scss';
</style>
